import React from 'react'
import './PersonalToday.scss'

const PersonalToday: React.FC = () => {
  return (
    <div className="personal-today">
      <div className="personal-today__header">
        <h1 className="personal-today__title">Mein Tag</h1>
      </div>
    </div>
  )
}

export default PersonalToday
